import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CartItem } from './cartStore';

export interface CustomerInfo {
  fullName: string;
  email: string;
  phone: string;
}

export interface OrderData {
  items: CartItem[];
  totalAmount: number;
  totalQuantity: number;
  customerInfo: CustomerInfo;
  orderId?: string;
  createdAt?: Date;
  orderType: 'cart' | 'buy_now'; // 'cart': từ giỏ hàng, 'buy_now': mua ngay
}

interface OrderStore {
  currentOrder: OrderData | null;

  // Actions
  createOrder: (items: CartItem[], totalAmount: number, totalQuantity: number) => void;
  createOrderFromCourse: (course: {
    id: number;
    name: string;
    image: string;
    price: number;
  }) => void;
  setCustomerInfo: (customerInfo: CustomerInfo) => void;
  clearOrder: () => void;
  generateOrderId: () => string;
  resetPaymentStore: () => void;
}

export const useOrderStore = create<OrderStore>()(
  persist(
    (set, get) => ({
      currentOrder: null,

      createOrder: (items, totalAmount, totalQuantity) => {
        const orderId = get().generateOrderId();
        const currentOrder: OrderData = {
          items,
          totalAmount,
          totalQuantity,
          customerInfo: {
            fullName: '',
            email: '',
            phone: '',
          },
          orderId,
          createdAt: new Date(),
          orderType: 'cart', // Đơn hàng từ giỏ hàng
        };

        set({ currentOrder });
      },

      createOrderFromCourse: (course) => {
        const orderId = get().generateOrderId();
        const cartItem: CartItem = {
          id: course.id,
          name: course.name,
          image: course.image,
          price: course.price,
          quantity: 1,
        };

        const currentOrder: OrderData = {
          items: [cartItem],
          totalAmount: course.price,
          totalQuantity: 1,
          customerInfo: {
            fullName: '',
            email: '',
            phone: '',
          },
          orderId,
          createdAt: new Date(),
          orderType: 'buy_now', // Đơn hàng mua ngay
        };

        set({ currentOrder });
      },

      setCustomerInfo: (customerInfo) => {
        const { currentOrder } = get();
        if (currentOrder) {
          set({
            currentOrder: {
              ...currentOrder,
              customerInfo,
            },
          });
        }
      },

      clearOrder: () => {
        set({ currentOrder: null });
      },

      generateOrderId: () => {
        const timestamp = Date.now();
        return `OME${timestamp}`;
      },

      resetPaymentStore: () => {
        // Placeholder - sẽ được xử lý ở component level
      },
    }),
    {
      name: 'order-storage',
      partialize: (state) => ({
        currentOrder: state.currentOrder,
      }),
    }
  )
);
